import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';
import Home from './pages/Home';
import PostDetail from './pages/PostDetail';
import { Header, Footer, type NavConfig } from "@diaboro87/ui";
import navConfigJson from "./config/nav.config.json"

import "@diaboro87/ui/styles.css";
import './index.css';

const rawNavConfig: unknown = navConfigJson;

function isNavConfig(config: unknown): config is NavConfig {
    if (typeof config !== 'object' || config === null) {
        return false;
    }

    const maybeConfig = config as {
        brand?: unknown;
        items?: unknown;
    };

    // brand may be either a string or an object { label, url }
    if (typeof maybeConfig.brand === 'string') {
        // ok
    } else if (typeof maybeConfig.brand === 'object' && maybeConfig.brand !== null) {
        const b = maybeConfig.brand as { label?: unknown; url?: unknown };
        if (typeof b.label !== 'string' || typeof b.url !== 'string') {
            return false;
        }
    } else {
        return false;
    }

    if (!Array.isArray(maybeConfig.items)) {
        return false;
    }

    // Recursive validator for nav items (items may contain nested items)
    function isNavItem(item: unknown): boolean {
        if (typeof item !== 'object' || item === null) {
            return false;
        }

        const maybeItem = item as {
            label?: unknown;
            url?: unknown;
            items?: unknown;
        };

        if (typeof maybeItem.label !== 'string') {
            return false;
        }

        // item must have either a url (string) or nested items (array of items)
        if (typeof maybeItem.url === 'string') {
            return true;
        }

        if (Array.isArray(maybeItem.items)) {
            for (const child of maybeItem.items) {
                if (!isNavItem(child)) {
                    return false;
                }
            }
            return true;
        }

        return false;
    }

    for (const item of maybeConfig.items) {
        if (!isNavItem(item)) {
            return false;
        }
    }

    return true;
}

if (!isNavConfig(rawNavConfig)) {
    throw new Error('Invalid navigation configuration loaded from "nav.config.json".');
}

const navConfig: NavConfig = rawNavConfig;
function Layout() {
    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Header config={navConfig} />
            <main style={{ flex: 1 }} aria-label="Main content">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}

const router = createBrowserRouter([
    {
        element: <Layout />,
        children: [
            { path: '/', element: <Home /> },
            { path: '/posts/:id', element: <PostDetail /> },
        ],
    },
]);

const rootElement = document.getElementById('root');

if (!rootElement) {
    throw new Error('Root element with id "root" not found');
}

ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);
